'use client'
import LockIcon from '@/app/icons/lock'
import UnlockIcon from '@/app/icons/unlock'
import Toggle from '@/components/toggle'
import { useState } from 'react'

type Props = { initialIsPrivate?: boolean }
const privateClassName = 'bg-gradient-error'
const publicClassName = 'bg-gradient-secondary'
const PrivateToggle = ({ initialIsPrivate }: Props) => {
    const [isPrivate, setIsPrivate] = useState(!!initialIsPrivate)
    return (
        <div className="h-9">
            <Toggle
                options={[
                    {
                        label: <UnlockIcon className="fill-giphyBlack mx-4 size-5" />,
                        gradientClassName: publicClassName,
                    },
                    {
                        label: <LockIcon className="fill-giphyBlack mx-4 size-5" />,
                        gradientClassName: privateClassName,
                    },
                ]}
                index={!isPrivate ? 0 : 1}
                onTransitionEnd={(index) => {
                    setIsPrivate(index === 1)
                }}
            />
            <input type="hidden" name="is_private" value={isPrivate ? 'true' : 'false'} />
        </div>
    )
}
export default PrivateToggle
